import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    // COMPANY_API_KEY: z.string(),
    // DATABASE_URL: z.string().url(),
    // OPEN_AI_API_KEY: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_PUSHER_KEY: z.string().optional(),
    NEXT_PUBLIC_PUSHER_CLUSTER: z.string().default("us2"),
    NEXT_PUBLIC_ACTIONCABLE_URL: z
      .string()
      .default("wss://websockets.fluid.app/cable"),
    NEXT_PUBLIC_FLUID_API_URL: z.string().default("https://api.fluid.app/api"),
    NEXT_PUBLIC_NEXT_API_URL: z
      .string()
      .default("https://checkout.fluid.app/api"),
    NEXT_PUBLIC_SPREEDLY_API_KEY: z.string().min(1),
    NEXT_PUBLIC_KOUNT_CLIENT_ID: z.string().optional(),
    NEXT_PUBLIC_DOMAIN_HOSTNAME: z
      .string()
      .default("https://checkout.fluid.app"),
  },
  // For Next.js >= 13.4.4, you only need to destructure client variables:
  experimental__runtimeEnv: {
    NEXT_PUBLIC_FLUID_API_URL: process.env.NEXT_PUBLIC_FLUID_API_URL,
    NEXT_PUBLIC_NEXT_API_URL: process.env.NEXT_PUBLIC_NEXT_API_URL,
    NEXT_PUBLIC_SPREEDLY_API_KEY: process.env.NEXT_PUBLIC_SPREEDLY_API_KEY,
    NEXT_PUBLIC_KOUNT_CLIENT_ID: process.env.NEXT_PUBLIC_KOUNT_CLIENT_ID,
    NEXT_PUBLIC_PUSHER_KEY: process.env.NEXT_PUBLIC_PUSHER_KEY,
    NEXT_PUBLIC_PUSHER_CLUSTER: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    NEXT_PUBLIC_ACTIONCABLE_URL: process.env.NEXT_PUBLIC_ACTIONCABLE_URL,
    NEXT_PUBLIC_DOMAIN_HOSTNAME: process.env.NEXT_PUBLIC_DOMAIN_HOSTNAME,
  },
});
